import styled from 'styled-components';
import { FormLabel } from 'modules/core/components/FormRow/styles';
import { COLORS } from 'modules/core/theme/colors';

import { FieldHint } from '../../../styles';

export const EstimateRow = styled.div`
  padding-bottom: 12px;

  ${FormLabel} {
    font-size: ${({ theme: { fontSize } }) => fontSize.sm};
  }
`;

export const EstimateValue = styled.div`
  position: relative;
`;

export const EstimateHint = styled(FieldHint)`
  position: absolute;
  top: 100%;
  right: 0;
  white-space: nowrap;
  line-height: 13px;
  color: ${COLORS.GREY_3};
`;
